/* Stylesheet */

.logo_container {
  display: flex;
  height: 221px;
  align-items: center;
  justify-content: center;

  .logo {
    height: auto;
    width: 232px;
  }
}
